import React from "react";
import Lottie from "lottie-react";
import json from "../../lotties/invoice-paper.json";

function LottieInvoice({ className, ...prop }) {
  return <Lottie animationData={json} className={className || "w-20 h-20"} {...prop} />;
}

export default LottieInvoice;
